import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    const base = new URL(import.meta.env.BASE_URL, window.location.href);
    const swUrl = new URL("sw.js", base);
    navigator.serviceWorker.register(swUrl, { scope: base.pathname }).catch(() => undefined);
  });
}
